<template><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
  <defs>
    <clipPath>
      <circle data-name="Ellipse 12" cx="8" cy="8" r="8" transform="translate(1362 462)" fill="#5f2121"/>
    </clipPath>
  </defs>
  <g data-name="Mask Group 7041" transform="translate(-1362 -462)" clip-path="url(#clip-path)">
    <g transform="translate(1356.821 462.825)">
      <path d="M0,0H27.733V16.64H0Z" transform="translate(-0.688 -1.145)" fill="#012169"/>
      <path d="M2.772,0,0,1.663,1,3.328H29.571l2.772-1.663L31.343,0Z" transform="translate(0.168 -2.571) rotate(30.96)" fill="#fff"/>
      <path d="M31.344,3.328l1-1.665L29.57,0H1L0,1.665,2.772,3.328Z" transform="translate(-1.545 14.067) rotate(-30.96)" fill="#fff"/>
      <path d="M20,0h5.547V16.64H20Z" transform="translate(-9.595 -1.145)" fill="#fff"/>
      <path d="M0,10H27.733v5.547H0Z" transform="translate(-0.688 -5.598)" fill="#fff"/>
      <path d="M22,0h3.328V16.64H22Z" transform="translate(-10.485 -1.145)" fill="#c8102e"/>
      <path d="M0,12H27.733v3.328H0Z" transform="translate(-0.688 -6.489)" fill="#c8102e"/>
      <path d="M42.576,25.547V24.253L35.487,20H33.33Z" transform="translate(-15.531 -10.052)" fill="#c8102e"/>
      <path d="M0,0,.665,1.109H8.933L10.782,0Z" transform="translate(-0.688 -1.145) rotate(30.96)" fill="#c8102e"/>
      <path d="M30,5.547h1.85L41.093,0H38.939L30,5.363Z" transform="translate(-14.048 -1.145)" fill="#c8102e"/>
      <path d="M11.1,20H9.246L0,25.544v0H2.156L11.1,20.184Z" transform="translate(-0.69 -10.052)" fill="#c8102e"/>
    </g>
  </g>
</svg>
</template>